import {Component} from '@angular/core';

import {ValueView} from '../../value-view';

@Component({
  selector: 'ax-date-value-view',
  templateUrl: './date-value-view.component.html',
})
export class DateValueViewComponent extends ValueView {}
